import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import messages from 'aurora-translations';
import { ADGMPanelInputsGeneratorBody } from 'aurora-components';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';

const UAEResidentBuyerEditDetails = ({ intl, classes, buyer, onChangeHandler }) => {
  const BUYER_DETAILS_SECTIONS = useMemo(() => {
    return [
      {
        fields: [
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.trade_license_number }),
            placeholder: intl.formatMessage({ ...messages.trade_license_number }),
            value: buyer?.tradeLicense,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.company_name_english }),
            placeholder: intl.formatMessage({ ...messages.company_name_english_hint }),
            value: buyer?.nameEn,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.company_name_arabic }),
            placeholder: intl.formatMessage({ ...messages.company_name_arabic_hint }),
            value: buyer?.nameAr,
            required: true,
            disabled: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.phone_number }),
            placeholder: intl.formatMessage({ ...messages.phone_number }),
            value: buyer?.phoneNumber,
            mask: createNumberMask(numberMaskWithoutDecimalOption),
            onChange: e => onChangeHandler('phoneNumber', e?.target?.value),
            required: true,
          },
          {
            type: 'text',
            label: intl.formatMessage({ ...messages.Email }),
            placeholder: intl.formatMessage({ ...messages.Email }),
            value: buyer?.email,
            onChange: e => onChangeHandler('email', e?.target?.value),
            required: true,
          },
        ],
      },
    ];
  }, [intl, buyer]);

  return (
    <ADGMPanelInputsGeneratorBody
      isEditable
      sections={BUYER_DETAILS_SECTIONS}
      bodyStyle={classes.buyerDetailsContent}
    />
  );
};

UAEResidentBuyerEditDetails.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  buyer: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default UAEResidentBuyerEditDetails;
